export enum DatePreset {
    Last7Days = "last-7-days",
    Last30Days = "last-30-days",
    ThisYear = "this-year",
}

export const DATE_PRESETS: { preset: DatePreset; label: string }[] = [
    { preset: DatePreset.Last7Days, label: "7 days" },
    { preset: DatePreset.Last30Days, label: "30 days" },
    { preset: DatePreset.ThisYear, label: "This year" },
];

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const startBuilders: Record<DatePreset, (today: Date) => Date> = {
    [DatePreset.Last7Days]: (today) => new Date(today.getTime() - 7 * ONE_DAY_MS),
    [DatePreset.Last30Days]: (today) => new Date(today.getTime() - 30 * ONE_DAY_MS),
    [DatePreset.ThisYear]: (today) => new Date(today.getFullYear(), 0, 1),
};

export const datePresetRange = ({
    preset,
    today,
}: {
    preset: DatePreset;
    today: Date;
}): [Date, Date] => [startBuilders[preset](today), today];
